 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"npm.echarts-wordcloud":"npm.echarts-wordcloud","npm.katex":"npm.katex","npm.uslug":"npm.uslug","npm.markdown-it":"npm.markdown-it","npm.unorm":"npm.unorm","npm.antv":"npm.antv","npm.regl":"npm.regl","npm.gl-matrix":"npm.gl-matrix","npm.pdfjs-dist":"npm.pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-09c06549":"bfe2bb05","chunk-0f6984c6":"93ff35f2","chunk-16091086":"d8710e52","chunk-176c6bf0":"beb24540","chunk-19dfb0a0":"4f3235e4","chunk-1af01f52":"f5e0bcea","chunk-26f2b85e":"c1b7ed65","chunk-2d0e17b4":"7532c1cb","chunk-3522ec84":"2d51ee05","chunk-36c715f2":"5a28dfe6","chunk-39ed8a8e":"b558a7b0","chunk-59a4b5e4":"98a3b45e","chunk-6662d280":"15e88efa","chunk-6ab0a927":"10dfbb0c","chunk-741918f0":"289bc818","chunk-76fcaf0f":"6c758e60","chunk-7a6755b2":"aebb704e","chunk-7bf2d4d2":"255955a0","chunk-e0660eb2":"80ca700c","chunk-4270cc8c":"727a1540","npm.echarts-wordcloud":"1f680943","chunk-391181f8":"23962ad8","chunk-5ac6bc68":"85c7c670","chunk-bf4f5f4a":"705500d6","npm.katex":"0e35976d","npm.uslug":"78c3abbb","npm.markdown-it":"51c695ac","npm.unorm":"40bc4064","chunk-59278938":"35aa20cc","chunk-6442d501":"5c50d6dd","npm.antv":"44268c9a","npm.regl":"d59acee3","npm.gl-matrix":"a615622a","chunk-115745d6":"94ebc126","chunk-594afbbc":"39845848","npm.pdfjs-dist":"42ffb837","chunk-10f2fc19":"c0490639"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-09c06549":1,"chunk-0f6984c6":1,"chunk-16091086":1,"chunk-176c6bf0":1,"chunk-19dfb0a0":1,"chunk-1af01f52":1,"chunk-26f2b85e":1,"chunk-3522ec84":1,"chunk-36c715f2":1,"chunk-39ed8a8e":1,"chunk-59a4b5e4":1,"chunk-6662d280":1,"chunk-6ab0a927":1,"chunk-741918f0":1,"chunk-76fcaf0f":1,"chunk-7a6755b2":1,"chunk-7bf2d4d2":1,"chunk-e0660eb2":1,"chunk-4270cc8c":1,"chunk-391181f8":1,"chunk-5ac6bc68":1,"chunk-bf4f5f4a":1,"chunk-59278938":1,"chunk-6442d501":1,"chunk-115745d6":1,"chunk-594afbbc":1,"chunk-10f2fc19":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.echarts-wordcloud":"npm.echarts-wordcloud","npm.katex":"npm.katex","npm.uslug":"npm.uslug","npm.markdown-it":"npm.markdown-it","npm.unorm":"npm.unorm","npm.antv":"npm.antv","npm.regl":"npm.regl","npm.gl-matrix":"npm.gl-matrix","npm.pdfjs-dist":"npm.pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-09c06549":"2a95c573","chunk-0f6984c6":"5d6170e2","chunk-16091086":"731ca38f","chunk-176c6bf0":"96a6705c","chunk-19dfb0a0":"c76f8ee1","chunk-1af01f52":"a772de46","chunk-26f2b85e":"30c331e5","chunk-2d0e17b4":"31d6cfe0","chunk-3522ec84":"05ab458f","chunk-36c715f2":"b07cc2b3","chunk-39ed8a8e":"2919f5a8","chunk-59a4b5e4":"a2a17e64","chunk-6662d280":"5d7caf1b","chunk-6ab0a927":"a7966144","chunk-741918f0":"c76bd8c9","chunk-76fcaf0f":"7dc212c5","chunk-7a6755b2":"41c54187","chunk-7bf2d4d2":"01a25c59","chunk-e0660eb2":"70588a28","chunk-4270cc8c":"147391a4","npm.echarts-wordcloud":"31d6cfe0","chunk-391181f8":"04270832","chunk-5ac6bc68":"31f622e6","chunk-bf4f5f4a":"236ca8d8","npm.katex":"31d6cfe0","npm.uslug":"31d6cfe0","npm.markdown-it":"31d6cfe0","npm.unorm":"31d6cfe0","chunk-59278938":"13b64544","chunk-6442d501":"3c3b0528","npm.antv":"31d6cfe0","npm.regl":"31d6cfe0","npm.gl-matrix":"31d6cfe0","chunk-115745d6":"1b3869e0","chunk-594afbbc":"36de939e","npm.pdfjs-dist":"31d6cfe0","chunk-10f2fc19":"b32d5245"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/knowservePlatform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.core-js","npm.echarts","npm.lodash","npm.zrender","npm.d3-selection","npm.d3-transition","npm.d3","npm.axios","npm.element-ui","npm.qs","npm.animate.css","npm.buffer","npm.html2canvas","npm.vue-print-nb","npm.vue-router","npm.vue","npm.vuex","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
